import React from 'react';
import { ErrorPage } from './ErrorPage.js';
import ErrorPageV3 from '../V3/pages/global/ErrorPageV3.js';

/**
 * ErrorBoundary — Catch errors in the component tree and display a fallback UI
 * Détecte la version active et affiche la page d'erreur appropriée (V3 ou V1/V2)
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // Logs détaillés en mode debug
    if (process.env.REACT_APP_DEBUG === 'true') {
      console.error('ErrorBoundary caught an error:', error);
      console.error('Component stack:', errorInfo.componentStack);
    }
    
    // Log minimal en production (toujours afficher les vraies erreurs)
    console.error('Error:', error.message);
    
    this.setState({ errorInfo });
  }

  resetError = () => {
    this.setState({ hasError: false, error: null, errorInfo: null });
  };

  render() {
    if (this.state.hasError) {
      const VERSION = process.env.REACT_APP_VERSION || 'v3';
      
      // Message utilisateur : toujours simple et rassurant
      const userMessage = "Une erreur inconnue s'est produite, nous sommes désolés. Veuillez réessayer.";
      
      // V3 : ErrorPageV3 avec bouton Réessayer
      if (VERSION === 'v3') {
        return (
          <ErrorPageV3
            errorCode="Oups !"
            message={userMessage}
            onRetry={this.resetError}
          />
        );
      }
      
      // V1/V2 : ErrorPage classique
      return <ErrorPage errorCode="Oups !" message={userMessage} />;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
